import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@/components/atoms/Button/Button';
import { CheckCircleIcon } from '@/components/atoms/Icon/CheckCircleIcon';
import { LayoutContainer } from '@/components/molecules/Layout/LayoutContainer';
import Modal from '@/components/atoms/Modal/Modal';
import { H2 } from '@/components/atoms/Typography/Heading';
import { Input } from '@/components/ui/input';
import { cn } from '@/utils/cn';
import * as React from 'react';
export const ShareCollectionModal = ({ shareCollectionLabels, className, isModalOpen, onClose, triggerButton, ...props }) => {
    const { heading, copyLabel, copySuccessLabel } = shareCollectionLabels;
    const [linkCopied, setLinkCopied] = React.useState(false);
    const handleCopyLink = async (event) => {
        event.preventDefault();
        try {
            await navigator.clipboard.writeText(window.location.href);
            setLinkCopied(true);
        }
        catch (err) {
            console.error('Failed to copy: ', err);
        }
    };
    const handleClose = () => {
        setLinkCopied(false);
        onClose?.();
    };
    return (_jsx(Modal, { openModal: isModalOpen, onClose: handleClose, heading: heading, description: copyLabel, triggerButton: triggerButton, className: "top-1/2 h-fit -translate-y-1/2 rounded-sm md:w-full md:max-w-112", children: _jsx("div", { className: cn(className), ...props, children: _jsxs(LayoutContainer, { palette: "palette-light", spacing: "standard", className: "bg-surface-primary-default text-type-default flex flex-col gap-3 pb-6 text-center", children: [heading && _jsx(H2, { className: "pt-6 md:pt-4", dangerouslySetInnerHTML: { __html: heading || '' } }), _jsx(Input, { type: "text", defaultValue: window.location.href, readOnly: true }), copyLabel && copySuccessLabel && (_jsxs(Button, { variant: "default", size: "small", className: "w-full", onClick: handleCopyLink, children: [linkCopied ? copySuccessLabel : copyLabel, linkCopied && _jsx(CheckCircleIcon, {})] }))] }) }) }));
};
export default ShareCollectionModal;
